module.exports = __webpack_public_path__ + "public/img/ico-header-close.1634ab91.svg";